export const sortData = [
  {
    name: 'Date',
  },
  {
    name: 'Relevance',
  },
];